import styled from 'styled-components';

export const LogoContainer = styled.div``;
